export default __webpack_public_path__ + "static/media/icon-arrow-pagination.147cb698.svg";